/* unplugin-vue-components disabled */import script from "./CollectList.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectList.vue?vue&type=script&setup=true&lang=js"

import "./CollectList.vue?vue&type=style&index=0&id=23490e5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23490e5e"]])

export default __exports__